// frontend/src/farm/rng.mjs
// A tiny seeded PRNG (mulberry32): the same seed always gives the same sequence, so every
// player sees the same lawn props, the same backdrop landscape and the same shooting star.
export function mulberry32(a) {
  let t = a >>> 0;
  return () => {
    t = (t + 0x6d2b79f5) >>> 0;
    let r = Math.imul(t ^ (t >>> 15), 1 | t);
    r = (r + Math.imul(r ^ (r >>> 7), 61 | r)) ^ r;
    return ((r ^ (r >>> 14)) >>> 0) / 4294967296;
  };
}
